import { MapTabState } from "./types";
import { createSlice } from '@reduxjs/toolkit'
import { PayloadAction } from "@reduxjs/toolkit";
import { GeoZonesTabState } from "../geoZonesTab/types";
import { MapTabToggleKey } from "@modules/map/tools/MapTools";

const initialState: MapTabState = {
  mapView: {
    currentTileProvider: "yandexMap",
    enabled: true
  },
  mapWeather: {
    current: [],
    enabled: false
  },
  toggles: {
    rosreestr: false,
    show_notes: false
  },
}

const mapTabSlice = createSlice({
  name: 'map_tab_slice',
  initialState,
  reducers: {
    resetMapTabState(state: MapTabState, action: PayloadAction) {
      return initialState
    },
    setMapTabToggleState(state: MapTabState, action: PayloadAction<{ id: MapTabToggleKey, enabled: boolean }>){
      state.toggles[action.payload.id] = action.payload.enabled
    },
    setMapTabMapViewEnabled(state: MapTabState, action: PayloadAction<{ enabled: boolean }>){
      state.mapView.enabled = action.payload.enabled
    },
    setMapTabWeatherEnabled(state: MapTabState, action: PayloadAction<{ enabled: boolean }>){
      state.mapWeather.enabled = action.payload.enabled
    },
    setMapTabLayerProvider(state: MapTabState, action: PayloadAction<{ provider : string }>){
      state.mapView.currentTileProvider = action.payload.provider
    },
    setMapTabWeatherLayers(state: MapTabState, action: PayloadAction<{ ids : string[] }>){
      state.mapWeather.current = action.payload.ids
    },
    setMapTabWeather(state: MapTabState, action: PayloadAction<{ id : string }>){
      const current = state.mapWeather.current.indexOf(action.payload.id)
      current !== -1 ? state.mapWeather.current.splice(current, 1) : state.mapWeather.current.push(action.payload.id)
    },
  }
})

export const actions = mapTabSlice.actions
export default mapTabSlice.reducer